import React, { PropsWithChildren } from "react";
import { Center, CenterProps, Spinner } from "@chakra-ui/react";

export const CODE_CHALLENGE_LOADING_HEIGHT = 200;

type CodeChallengeLoadingProps = PropsWithChildren<CenterProps> & {
  height?: string | number;
};

export function CodeChallengeLoading({
  children,
  height = CODE_CHALLENGE_LOADING_HEIGHT,
  ...props
}: CodeChallengeLoadingProps) {
  return (
    <Center css={{ height }} fontSize="md" {...props}>
      <Spinner mr="2" size="sm" />
      {children}
    </Center>
  );
}
